function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';

var TabPanels = function TabPanels(_ref) {
  var value = _ref.value,
      renderActiveOnly = _ref.renderActiveOnly,
      children = _ref.children;
  return React.Children.toArray(children.filter(function (child, index) {
    var tabKey = child.props.value || index;
    return !renderActiveOnly || tabKey === value;
  }).map(function (child, index) {
    var _child$props = child.props,
        childValue = _child$props.value,
        _child$props$sx = _child$props.sx,
        sx = _child$props$sx === void 0 ? {} : _child$props$sx;
    var tabKey = childValue || index;
    var childNewProps = {
      key: tabKey,
      sx: sx
    };

    if (tabKey !== value) {
      childNewProps.sx = _objectSpread(_objectSpread({}, sx), {}, {
        display: 'none'
      });
    }

    return /*#__PURE__*/React.cloneElement(child, childNewProps);
  }));
};

TabPanels.displayName = 'TabPanels';
TabPanels.defaultProps = {
  renderActiveOnly: true
};
export default TabPanels;
export { TabPanels };